import { useEffect, useState } from "react";
import api from "../../api";
import SponserForm from "./components/SponserForm";

const Sponser2main = () => {
  const [sponser, setSponser] = useState([]);

  const loadSponser = async () => {
    try {
      const { data } = await api.get("/sponsers2");

      console.log("sponser2", data.sponsers);
      setSponser(data.sponsers);
    } catch (error) {
      console.error("Error loading sponsors:", error);
    }
  };

  useEffect(() => {
    loadSponser();
  }, []);

  const createSponser = async () => {
    try {
      const { data } = await api.post("/sponsers2", {
        sponser_image: "",
        sponser_link: "",
      });
      console.log("Sponser created:", data);
    } catch (error) {
      console.error("Error creating sponsor:", error);
    } finally {
      loadSponser();
    }
  };

  return (
    <div className="pl-72 font-Prompt mx-auto space-y-6">
      <div className="flex justify-between items-center">
        <div className=" text-xl mt-5"> SPONSOR HOME </div>
      </div>
      <div
        className="flex border border-green-500  p-4 rounded-2xl w-[125px] bg-green-400 cursor-pointer"
        onClick={createSponser}
      >
        Add Sponser
      </div>

      <div className="grid grid-cols-4 gap-4 ">
        {sponser?.map((item, index) => {
          return (
            <div key={index} className="">
              <SponserForm sponser={item} reloadData={loadSponser} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Sponser2main;
